import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'date',
    standalone: true,
    pure: true
})
export class NgxDatePipe implements PipeTransform {

    private translateService = inject(TranslateService);
    private datePipe = inject(DatePipe);

    public transform(value: any, pattern: string = 'fullDate', locale?: string): any {
        if (!value) return '';
        const loc = locale ?? this.translateService.currentLang ?? 'en';
        return this.datePipe.transform(value, pattern, undefined, loc);
    }

}
